import React from "react";

const PictureBanner = (props) => {
    return (
        <div>
            <div class="card">
                <div class="card-image waves-effect waves-block waves-light">
                    <img class="activator reactive-img" src={props.picture}></img>
                </div>
            </div>
        </div>
    )
}

export default PictureBanner;

